import { Flex } from "@chakra-ui/react";
import type { DTO } from "@equidefi/shared/types";
import { Heading, Icon, Paper, Text } from "@equidefi/ui";
import { useGetDocumentURLs } from "../../hooks/useAccreditation";
import { AccreditationFileList } from "./AccreditationFileList";

type StepIconProps = {
  completed: boolean;
  text: string;
};

export const StepIcon = ({ completed, text }: StepIconProps) => {
  const CustomIcon = completed ? Icon.Check : Icon.X;
  const color = completed ? "green" : "red";

  return (
    <Flex align="center" gap="5px">
      <CustomIcon size="2em" color={color} />
      <Text mb="0">{text}</Text>
    </Flex>
  );
};

type UploadSectionProps = {
  vault: DTO.Vault;
  investment: DTO.Investment;
  offering: DTO.Offering;
  accreditationFiles: DTO.AccreditationFile[];
  refetch: () => Promise<void>;
};

export const ViewAccreditationFiles = (props: UploadSectionProps) => {
  const { vault, accreditationFiles } = props;

  // The utility bill is stored as a private S3 object, so it must be served
  // through a presigned download URL — vault.utility_bill is the raw object URL
  // and opening it directly returns an S3 XML error. (EPP-3395)
  const { data: documentUrls } = useGetDocumentURLs(vault?.id);
  const utilityBillUrl = documentUrls?.utility_bill;

  return (
    <>
      <Paper p="4" my="4">
        <Heading mb="5" fontWeight="bold">
          Accreditation Verification Documents
        </Heading>
        <AccreditationFileList
          noFilesWarning={false}
          vaultId={vault?.id}
          files={accreditationFiles}
          isEditable={false}
          isDeletable={false}
        />
      </Paper>

      <Paper p="4" my="4">
        <Heading mb="5" fontWeight="bold">
          Address Verification Document
        </Heading>
        <AccreditationFileList
          noFilesWarning={false}
          vaultId={vault?.id}
          files={
            utilityBillUrl
              ? [
                  {
                    name: "File",
                    type: "Address Verification",
                    url: utilityBillUrl,
                    deletable: false,
                  },
                ]
              : []
          }
          isEditable={false}
          isDeletable={false}
        />
      </Paper>
    </>
  );
};
